import { useTypedQuery } from "hooks";
import { AccountSettingsQueryKeys } from "modules/AccountSettings/queryKeys";
import { ApiInstance } from "utils/Api";

export const useNotificationsListQuery = () => {
  const { data, isLoading } = useTypedQuery({
    queryKey: AccountSettingsQueryKeys.notificationsList,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.notification_elements
  });

  return { notificationsList: data ?? [], isLoading };
};
